/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment, createRef } from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";
import Request from "../../utils/request";
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import BScroll from "@better-scroll/core";

class PipelineCommunity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showGlobalView: false,
      sortType: 'hot',
      commentVal: '',
      baseList: [], // 初始数据
      allList: [],
      page: {
        pageNum: 1,
        pageSize: 20,
      },
      hasMore: true,
      bannerImgHeight: 0,
    };
    this.pageId = utils.getPageId();
    this.bodyScrollTop = 0;
    this.scrollLock = false; // 滚动计算锁定
    this.scrollRef = createRef();
    this.baseSwiperRef = createRef();
    this.fixedCommunityBody = createRef();

    this.screenRatio = 1;
    if (typeof window !== 'undefined') {
      this.screenRatio = window.document.body.clientWidth / 375;
    }
  }

  componentDidMount() {
    this.getBaseListData();
    this.measureBannerImg();

    this.commentScroll = new BScroll(this.scrollRef.current, {
      // 配置项，更多可参考官方文档
      probeType: 3,
      click: true,
      tap: 'tap',
      momentum: true,
      momentumLimitDistance: 30,
      deceleration: 0.003,
      preventDefaultException: {
        className: /(^|\s)like-container(\s|$)/,
      },
    });
    this.commentScroll.on('scroll', this.handleCommentListScroll)
  }

  componentDidUpdate(prevProps, prevState) {
    // 内容更新时，需要重新刷新滚动容器
    if (prevState.allList.length !== this.state.allList.length) {
      this.commentScroll.refresh();
    } 
  }

  measureBannerImg = () => {
    // 测量banner图高度
    let bodyWidth = 375;
    if (typeof window !== 'undefined') {
      bodyWidth = window.document.body.clientWidth;
    }
    
    const imageEl = new Image();
    imageEl.src = this.props.config.baseConfig.bannerImg;
    imageEl.onload = () => {
      let bannerImgHeight = 0;
      bannerImgHeight = parseInt((imageEl.height / imageEl.width) * bodyWidth, 10);
      this.setState({
        bannerImgHeight,
      });
    }
  }

  getBaseListData = () => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/hot?access_token=znSnA7pxO35wtPBaur',
      method: "get",
      withCredentials: true,
      params: {
        page: 1,
        page_size: 50,
        pos: this.pageId,
      },
    }).then((res) => {
      if (res.data.status === 0) {
        this.setState({
          baseList: res.data.data.list || [],
        }, () => {
          // 初始化轮播组件
          if (this.state.baseList.length < 5) {
            return;
          }
          const swiper = new Swiper(this.baseSwiperRef.current, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            allowTouchMove: false,
            direction: 'vertical',
            loop: true,
            autoHeight: true,
            centeredSlides: true,
            pagination: false,
            navigation: false,
            loopAdditionalSlides: 10,
            speed: 500,
            autoplay: {
              delay: 1500,
              disableOnInteraction: false,
            },
          });
        });
      }
    })
  }

  fetchMoreCommentData = () => {
    if (!this.state.hasMore) {
      return;
    }
    const sortType = this.state.sortType;
    const page = this.state.page;
    let reqUrl = '';
    if (sortType === 'hot') {
      reqUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/hot?access_token=znSnA7pxO35wtPBaur';
    } else {
      reqUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/latest?access_token=znSnA7pxO35wtPBaur';
    }
    Request({
      url: reqUrl,
      method: "get",
      withCredentials: true,
      params: {
        page: page.pageNum,
        page_size: page.pageSize,
        pos: this.pageId,
      },
    }).then((res) => {
      if (res.data.status === 0) {
        let allList = this.state.allList;
        const currentList = res.data.data.list || [];
        allList = allList.concat(currentList);
        page.pageNum += 1;
        this.setState({
          hasMore: currentList.length > 0,
          allList,
          page,
        }, () => {
          // 数据渲染完毕之后释放锁定
          this.scrollLock = false;
        });
      } else {
        this.setState({
          hasMore: false,
        });
        this.scrollLock = false;
      }
    })
  }

  handleShowGlobalView = () => {
    this.setState({
      showGlobalView: true,
    });
    setTimeout(() => {
      this.fixedCommunityBody.current.style.transform = 'translateY(0)';
    }, 10);
    this.fetchMoreCommentData();

    document.querySelector("body").style.touchAction = 'none'
  }

  handleToggleSortType = (sortType) => {
    const page = this.state.page;
    page.pageNum = 1;
    this.setState({
      sortType,
      page,
      allList: [],
      hasMore: true,
    }, this.fetchMoreCommentData);
  }

  handleSendMsg = async () => {
    const userCookie = await utils.getCookie('u');
    console.log(userCookie, '用户cookie')
    if (userCookie) {
      // 发布留言
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/save?access_token=znSnA7pxO35wtPBaur',
        method: "post",
        withCredentials: true,
        data: {
          comment: this.state.commentVal,
          pos: this.pageId,
        },
      }).then((res) => {
        if (res.data.status === 0) {
          this.setState({
            commentVal: '',
          });
          // 将新发布的一条消息推入列表
          const newComment = res.data.data.comment || {};
          if (this.state.showGlobalView) {
            const allList = this.state.allList;
            allList.push(newComment);
            this.setState({
              allList,
            });
          } else {
            const baseList = this.state.baseList;
            baseList.push(newComment);
            this.setState({
              baseList,
            });
          }
        } else {
        }
      })
    } else if (typeof window !== 'undefined'){
      window.Jockey.send('login');
    }
  }

  handleToggleBaseLikeStatus = async (baseIndex) => {
    const baseList = this.state.baseList;
    const toggleStatus = baseList[baseIndex].self_like ? 0 : 1; // 切换状态
    baseList[baseIndex].self_like = Boolean(toggleStatus);
    if (toggleStatus === 1) {
      baseList[baseIndex].like_cnt += 1;
    } else {
      baseList[baseIndex].like_cnt -= 1;
    }
    const userCookie = await utils.getCookie('u');
    if (userCookie) {
      // 点赞与取消
      this.setState({
        baseList,
      });
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/like?access_token=znSnA7pxO35wtPBaur',
        method: "post",
        withCredentials: true,
        data: {
          comment_id: baseList[baseIndex].id,
          status: toggleStatus,
        },
      }).then((res) => {
        if (res.data.status === 0) {
          console.log('操作成功');
        }
      });
    } else if (typeof window !== 'undefined') {
      window.Jockey.send('login');
    }
  }

  handleToggleLikeStatus = async (index) => {
    const allList = this.state.allList;
    const toggleStatus = allList[index].self_like ? 0 : 1; // 切换状态
    allList[index].self_like = Boolean(toggleStatus);
    if (toggleStatus === 1) {
      allList[index].like_cnt += 1;
    } else {
      allList[index].like_cnt -= 1;
    }
    const userCookie = await utils.getCookie('u');
    if (userCookie) {
      // 点赞与取消
      this.setState({
        allList,
      });
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/like?access_token=znSnA7pxO35wtPBaur',
        method: "post",
        withCredentials: true,
        data: {
          comment_id: allList[index].id,
          status: toggleStatus,
        },
      }).then((res) => {
        if (res.data.status === 0) {
          console.log('操作成功');
        }
      });
    } else if (typeof window !== 'undefined') {
      window.Jockey.send('login');
    }
  }

  handleCloseFixedCommunity = () => {
    this.setState({
      showGlobalView: false,
    });
    setTimeout(() => {
      this.fixedCommunityBody.current.style.transform = 'translateY(100%)';
    }, 10);

    document.querySelector("body").style.touchAction = 'auto'
  }

  handleCommentValChange = (event) => {
    const val = event.target.value;
    this.setState({
      commentVal: val,
    });
  }

  handleCommentListScroll = (event) => {
    if (!this.state.hasMore) {
      return;
    }
    if (this.scrollLock) {
      // 滚动锁定情况不再请求下一页
      return;
    }
    const maxScrollHeight = document.querySelector('.scroll-content').clientHeight - this.scrollRef.current.clientHeight;
    const currentScrollTop = event.y;
    // 滚动条距离底部小于100，加载下一页
    if (maxScrollHeight + currentScrollTop < 100 && currentScrollTop !== 0) {
      console.log(maxScrollHeight, currentScrollTop, '加载下一页');
      this.scrollLock = true;
      this.fetchMoreCommentData();
    }
  }

  render() {
    const { baseConfig, itemList } = this.props.config;
    const allList = this.state.allList;

    return (
      <div
        className="pipeline-community"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px'
        }}
      >
        {baseConfig.showTitle && (
          <div className="title" style={{ color: baseConfig.titleColor }}>
            {baseConfig.title}
          </div>
        )}
        {baseConfig.showTitle && (
          <div className="sub-title" style={{ color: baseConfig.titleColor }}>
            {baseConfig.subTitle}
          </div>
        )}
        <div
          className="content-panel"
          style={{ backgroundImage: `url(${utils.formatImgUrl(baseConfig.bgImg, this.props.webpSupport)})` }}
        >
          <div className="comment-list comment-swiper-container" ref={this.baseSwiperRef}>
            <div className="swiper-wrapper">
              {this.state.baseList.map((item, index) => {
                return (
                  <div className="comment-item swiper-slide"  key={item.id}>
                    <img className="avatar" src={utils.formatImgUrl(item.avatar, this.props.webpSupport)} alt="" />
                    <div className="comment-detail-container">
                      <div className="user-info">
                        <div className="username">{item.name}</div>
                        <div className="like-container" onClick={this.handleToggleBaseLikeStatus.bind(this, index)}>
                          {item.like_cnt}
                          {item.self_like ?
                            (<img className="like-icon" src={utils.formatImgUrl(baseConfig.likeIcon, this.props.webpSupport)} alt="" />) :
                            (<img className="like-icon" src={utils.formatImgUrl(baseConfig.unlikeIcon, this.props.webpSupport)} alt="" />)
                          }
                        </div>
                      </div>
                      <div className="ballon-content" style={{ color: baseConfig.contentColor, backgroundColor: baseConfig.contentBgColor }}>
                        {item.comment}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            <div className="swiper-pagination"></div>
          </div>
          <div className="input-bar">
            <input className="input-text" value={this.state.commentVal} onChange={this.handleCommentValChange} placeholder={baseConfig.inputPlaceholder} />
            <img className="submit-btn" src={utils.formatImgUrl(baseConfig.sendBtnImg, this.props.webpSupport)} onClick={this.handleSendMsg} alt="发送" />
          </div>
          <img
            className="view-more-btn"
            src={utils.formatImgUrl(baseConfig.viewMoreImg, this.props.webpSupport)}
            onClick={this.handleShowGlobalView}
            style={{ height: this.screenRatio * 40 }}
            alt="查看更多"
          />
        </div>

        {/* fixed全局模板 */}
        <div className="fixed-community-panel" style={{ display: this.state.showGlobalView ? 'block' : 'none' }}>
          <div className="community-mask"></div>
          <div className="community-body" ref={this.fixedCommunityBody}>
            <img
              className={baseConfig.bannerImg ? 'close-btn hasBanerImg' : 'close-btn'}
              onClick={this.handleCloseFixedCommunity}
              src={utils.formatImgUrl('https://static.shihuocdn.cn/admin/files/20210716/1fbcc8f984b89ec2a1dd2cacfec88900.png', this.props.webpSupport)}
              alt=""
            />
            {baseConfig.bannerImg && (
              <img className="banner-img" src={utils.formatImgUrl(baseConfig.bannerImg, this.props.webpSupport)} style={{ height: this.screenRatio * 100 }} alt="" />
            )}
            <div className="header">
              <div className="community-title">留言板</div>
              <div className="toggle-bar">
                <div className="hot-btn" onClick={this.handleToggleSortType.bind(this, 'hot')} style={{ color: this.state.sortType === 'hot' ? baseConfig.checkedTabColor : baseConfig.uncheckedTabColor }} >最热</div>
                |
                <div className="new-btn" onClick={this.handleToggleSortType.bind(this, 'new')} style={{ color: this.state.sortType === 'new' ? baseConfig.checkedTabColor : baseConfig.uncheckedTabColor }}>最新</div>
              </div>
            </div>
            <div className="content-panel" style={{ backgroundImage: `url(${utils.formatImgUrl(baseConfig.subPageBgImg, this.props.webpSupport)})` }}>
              <div
                className="scroll-comment-container"
                ref={this.scrollRef}
                style={{
                  height: `calc(100vh - 292px - ${this.screenRatio * (baseConfig.bannerImg ? 100 : 0)}px)`
                }}
              >
                <div className="scroll-content">
                  {allList.map((item, index) => {
                    return (
                      <div className="comment-item" key={item.id}>
                        <img className="avatar" src={utils.formatImgUrl(item.avatar, this.props.webpSupport)} alt="" />
                        <div className="comment-detail-container">
                          <div className="user-info">
                            <div className="username">{item.name}</div>
                            <div className="like-container" onClick={this.handleToggleLikeStatus.bind(this, index)}>
                              {item.like_cnt}
                              {item.self_like ?
                                (<img className="like-icon" src={utils.formatImgUrl(baseConfig.likeIcon, this.props.webpSupport)} alt="" />) :
                                (<img className="like-icon" src={utils.formatImgUrl(baseConfig.unlikeIcon, this.props.webpSupport)} alt="" />)
                              }
                            </div>
                          </div>
                          <div className="ballon-content" style={{ color: baseConfig.contentColor, backgroundColor: baseConfig.contentBgColor }}>
                            {item.comment}
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="input-bar">
                <input className="input-text" value={this.state.commentVal} onChange={this.handleCommentValChange} placeholder={baseConfig.inputPlaceholder} />
                <img className="submit-btn" src={utils.formatImgUrl(baseConfig.sendBtnImg, this.props.webpSupport)} onClick={this.handleSendMsg} alt="发送" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PipelineCommunity.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCommunity };
export default PipelineCommunity;



// WEBPACK FOOTER //
// ./components/pipeline-community/index.js